var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "min-h-hero flex flex-col pt-shh lg:pt-0 pb-15 bg-paint px-ogs-large",
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showColourSelector
            ? _c("ColourSelector", {
                attrs: {
                  "is-paint-product": true,
                  "default-colour": _vm.selectedColour,
                  palettes: _vm.palettes,
                  "swatch-book": _vm.swatchBook,
                  "colour-styles": _vm.colourStyles,
                },
                on: { "select-colour": _vm.handleSelectColour },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-1 flex flex-col justify-center items-center lg:py-15",
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col items-center pt-36 pb-16 lg:pt-0" },
            [
              _c(
                "label",
                {
                  staticClass:
                    "text-xxs text-theme font-semibold uppercase mb-1",
                },
                [_vm._v("Selected colour")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "relative" },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.isLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute inset-0 flex items-center justify-center z-20",
                            attrs: {
                              role: "alert",
                              "data-testid": "loading-message",
                            },
                          },
                          [
                            _c("LoaderSpinner", {
                              staticClass: "w-10 h-10 text-theme",
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative transition-opacity duration-300 z-10",
                      class: {
                        "opacity-25": _vm.isLoading,
                        "opacity-100": !_vm.isLoading,
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "link flex items-center border-b border-theme py-2 space-x-2",
                          on: {
                            click: function ($event) {
                              _vm.showColourSelector = true
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "text-xl text-theme" }, [
                            _vm._v(_vm._s(_vm.selectedColour.title)),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "caret bg-theme",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedColour.accent || _vm.selectedColour.ourFaves
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-center items-center space-x-3 mt-5",
                    },
                    [
                      _vm.selectedColour.accent
                        ? _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "h-2 text-theme" },
                                [_c("LabelAccent")],
                                1
                              ),
                              _vm._v(" "),
                              _c("ButtonInfo", {
                                staticClass: "ml-1",
                                attrs: {
                                  themed: "",
                                  heading: "Accent Colours",
                                  body: "Our accent range is our dark, bold and bright colours.  It comes in a hard wearing low sheen finish and is available in our wall paint, enamel paint and exterior paint only.",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedColour.ourFaves
                        ? _c(
                            "div",
                            { staticClass: "h-2 text-theme" },
                            [_c("LabelOurFaves")],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "border border-theme rounded-xl w-full max-w-xl mx-px",
            },
            [
              _c(
                "div",
                {
                  staticClass: "border-b border-theme px-10 sm:px-15 pt-6 pb-4",
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-5 flex justify-center" },
                    [
                      _vm.paintTypes.length > 1
                        ? _c("SelectMenuWithLabel", {
                            staticClass: "mb-4 text-theme",
                            attrs: {
                              id: "paint-type-select",
                              value: _vm.product.slug,
                              label: "Paint Type",
                              themed: "",
                              "info-heading": "Paint Type",
                              "info-text":
                                "Different uses call for different paints. Pick your paint below",
                              "select-style": "alternative",
                              options: _vm.paintTypeOptions,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.changePaintType($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.product.description
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "text-theme text-sm md:text-base text-center",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.product.description) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                !_vm.isLoading
                  ? _c(
                      "form",
                      {
                        attrs: { id: "variantForm", name: "variantForm" },
                        on: { submit: _vm.handleSubmit },
                      },
                      [
                        _c("ProductVariantSelector", {
                          staticClass:
                            "flex justify-center divide-x divide-theme h-24 lg:h-15",
                          attrs: {
                            sheens: _vm.variantSheens,
                            sizes: _vm.variantSizes,
                            "selected-sheen": _vm.selectedSheen,
                            "selected-size": _vm.selectedSize,
                            "selector-style": "alternative",
                            "info-heading": "Sheen",
                            "info-text":
                              "Different people prefer different finishes. Choose your preferred sheen",
                          },
                          on: {
                            "change-sheen": function ($event) {
                              _vm.selectedSheen = $event
                            },
                            "change-size": function ($event) {
                              _vm.selectedSize = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-center divide-x divide-theme h-24 lg:h-15",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-1 flex items-center justify-center",
                          },
                          [
                            _c("LoaderSpinner", {
                              staticClass: "w-10 h-10 text-theme",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-1 flex items-center justify-center",
                          },
                          [
                            _c("LoaderSpinner", {
                              staticClass: "w-10 h-10 text-theme",
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col sm:flex-row items-center border-t border-theme py-5 sm:py-3 px-10 gap-y-2 gap-x-8",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "flex-1 w-full sm:w-auto btn-pill min-h-10",
                      class: {
                        "btn-pill--alt":
                          _vm.selectedColour.textColour === "white",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$store.commit("openPaintCalculator")
                        },
                      },
                    },
                    [_vm._v("\n          Size up my space\n        ")]
                  ),
                  _vm._v(" "),
                  _c("ProductAddToCartForm", {
                    staticClass: "flex-1 btn-pill--strong",
                    class: {
                      "btn-pill--strong-alt":
                        _vm.selectedColour.textColour === "white",
                    },
                    attrs: {
                      form: "variantForm",
                      "message-reversed": true,
                      "button-style": "pill",
                      variant: _vm.variantSelected,
                      loading: _vm.isLoading,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gap-x-3 flex items-center lg:hidden mt-6" },
            [
              _c("SiteFavouritesAddButton", {
                attrs: { "selected-colour": _vm.selectedColour },
              }),
              _vm._v(" "),
              _c("ButtonFullScreenColour", {
                attrs: { story: _vm.selectedColour.text },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.testPotProductId
            ? _c(
                "div",
                { staticClass: "lg:hidden mt-6 flex justify-center" },
                [
                  _c(
                    "TestPotAddToCart",
                    {
                      staticClass: "min-h-10",
                      attrs: {
                        "button-style": "alt",
                        loading: _vm.isLoading,
                        "colour-title": _vm.selectedColour.title,
                        "test-pot": _vm.testPot,
                        sku: _vm.variantSelected ? _vm.variantSelected.sku : "",
                        "product-title": _vm.product.title,
                        sheen: _vm.selectedSheen.title,
                        "paint-colour": _vm.selectedColour.hex,
                        "text-colour": _vm.selectedColour.textColour,
                        source: "paint_product_page",
                      },
                    },
                    [_vm._v(_vm._s(_vm.testPotButtonText))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-12 items-end gap-x-gs gap-y-4" },
        [
          _c(
            "div",
            {
              staticClass: "hidden lg:col-span-5 lg:flex items-center gap-x-5",
            },
            [
              _vm.testPotProductId
                ? _c(
                    "div",
                    [
                      _c(
                        "TestPotAddToCart",
                        {
                          staticClass: "min-h-10",
                          attrs: {
                            "button-style": "alt",
                            loading: _vm.isLoading,
                            "colour-title": _vm.selectedColour.title,
                            "test-pot": _vm.testPot,
                            sku: _vm.variantSelected
                              ? _vm.variantSelected.sku
                              : "",
                            "product-title": _vm.product.title,
                            sheen: _vm.selectedSheen.title,
                            "paint-colour": _vm.selectedColour.hex,
                            "text-colour": _vm.selectedColour.textColour,
                            source: "paint_product_page",
                          },
                        },
                        [_vm._v(_vm._s(_vm.testPotButtonText))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gap-x-3 flex items-center lg:col-span-2" },
                [
                  _c("SiteFavouritesAddButton", {
                    attrs: { "selected-colour": _vm.selectedColour },
                  }),
                  _vm._v(" "),
                  _c("ButtonFullScreenColour", {
                    attrs: { story: _vm.selectedColour.text },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-span-12 lg:col-span-2 pt-20 lg:pt-0 flex justify-center items-center",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "link flex flex-col justify-center items-center focus:outline-none text-theme",
                  on: { click: _vm.handleClick },
                },
                [
                  _c("span", { staticClass: "text-xl" }, [_vm._v("Explore")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "w-4 h-6 mt-3" },
                    [_c("IconArrowDown")],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }